import type {
	ShopDto,
	UpdateOneZendeskIntegrationDto,
} from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateZendeskIntegration(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/integrations/zendesk",
		{
			invalidate: invalidateShop,
			mapVariables: (requestBody: UpdateOneZendeskIntegrationDto) => ({
				params: { path: { shopId: shop.id } },
				body: requestBody,
			}),
		},
	);
}
